import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ModuleTypeForm from '../../../components/forms/ModuleTypeForm';
import { useModuleTypeApi } from '../../../hooks/useModuleTypeApi';
import { useNavigate } from 'react-router-dom';
import { ModuleTypeDTO } from '../../../services/apiClient';

const ModuleTypeCreate: React.FC = () => {
  const { create, isLoading } = useModuleTypeApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Module Types', href: '/admin/moduletypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ModuleTypeDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/moduletypes');
    } catch (error) {
      console.error('Error creating ModuleType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/moduletypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ModuleType.Edit"
    >
      <ModuleTypeForm
        initialValues={{} as ModuleTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/moduletypes')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default ModuleTypeCreate;
